import * as React from 'react';
import styled from 'styled-components';

import { IData } from './Landing';

interface IProps {
    member: IData['learningPath']['pathGroup']['members'][0];
}

const Wrapper = styled.div`
    margin: 0 -10px 0.5em -10px;
    display: flex;
    align-items: center;
`;

const ImgTainer = styled.div`
    width: 80px;
    flex-shrink: 0;
    margin: 0 10px;
    img {
        width: 80px;
        height: 80px;
        object-fit: cover;
    }
`;

const NameTainer = styled.div`
    margin: 0 10px;
    flex-grow: 1;
`;

function PathGroupMember({ member }: IProps): JSX.Element {
    const person = member.person;
    return <Wrapper>
        <ImgTainer>
            <img src={person.profilePicSrc || '/static/images/profile-silouette.png'} alt='profile picture' />
        </ImgTainer>
        <NameTainer>{person.firstName} {person.lastName}</NameTainer>
    </Wrapper>;
}

export default PathGroupMember;
